var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQforQuantessenceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 115,
    viewBox: "0 0 174 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1512 113.777H31.0466C14.0055 113.777 0 100.314 0 83.7836V35.127H34.0822V113.777H34.1512ZM36.635 113.777H36.083V33.7273H0V33.1941H36.635V113.777ZM0.0689861 30.528C0.827903 14.6646 14.4884 2.00056 31.0466 2.00056H34.1512V30.528H0.0689861ZM36.635 30.7946H36.083V0.534199H30.9776C23.0435 0.534199 14.7644 3.46693 8.96901 8.79915C4.27753 13.1316 4.55349 12.865 9.38296 8.46589C15.2473 3.06701 22.9055 0.0676284 30.9776 0.0676284H36.566V30.7946H36.635Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.022 106.845C139.64 111.177 132.741 113.776 125.221 113.776H39.3945V81.1165C42.6372 86.1155 52.7101 85.9822 52.7101 85.9822H104.523C105.42 85.9822 106.317 85.9155 107.214 85.7156L73.0628 66.6529L86.3784 44.3908L121.289 63.8534V46.3904C121.289 37.5922 113.906 30.4604 104.799 30.4604H82.1698H39.3945V1.93293H125.221C142.262 1.93293 156.268 15.3968 156.268 31.9267V83.4494L170.273 91.2478L156.958 113.51L145.022 106.845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQforQuantessenceWhite);
export default __webpack_public_path__ + "static/media/Q for Quantessence White.6a3c417d8237a5e56869e8e6060964ac.svg";
export { ForwardRef as ReactComponent };